// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalMeditateOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 96 96"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<defs>
			<path
				d="M45.607 66.714c-7.72-.354-13.418-2.756-16.937-7.136-4.4-5.476-4.31-12.717-4.071-15.56 7.434-.474 15.237 1.417 19.54 4.154 11.723 7.452 19.03 7.771 19.336 7.781l.066.001a2 2 0 0 0 .065-3.999c-.065-.002-6.511-.287-17.32-7.159-5.678-3.61-12.386-4.999-18.678-4.929-.041-1.53 1.639-4.746 3.036-6.153 4.167-4.198 9.275-4.622 13.73-4.477 10.675.342 18.919 10.646 24.374 17.464 1.148 1.434 2.139 2.673 3.038 3.68 3.138 3.511 6.877 5.61 9.585 6.782-5.198 3.591-17.554 10.388-35.764 9.551M87.433 55.99a2.002 2.002 0 0 0-1.47-1.437c-.064-.016-6.523-1.61-11.194-6.838-.827-.925-1.787-2.124-2.898-3.513-5.914-7.39-14.85-18.562-27.37-18.963-5.008-.164-11.418.34-16.696 5.656-1.57 1.581-4.33 5.878-4.202 9.214-5.946.656-11.185 2.567-14.332 5.024a2 2 0 1 0 2.46 3.153c2.457-1.917 5.524-3.102 8.813-3.747-.217 3.831.099 11.41 4.983 17.515 4.268 5.333 10.962 8.245 19.896 8.656 1.123.052 2.223.076 3.304.076 24.067 0 37.55-12.277 38.136-12.823a2 2 0 0 0 .57-1.973"
				id="GoalMeditateOutline_tsx__a"
			/>
		</defs>
		<use fill="#FFF" xlinkHref="#GoalMeditateOutline_tsx__a" fillRule="evenodd" />
	</svg>
);
export default GoalMeditateOutline;
